<template>
    <div class="form-group">
        <v-select
            label="fullname"
            :placeholder="placeholder"
            :filterable="false"
            :options="members"
            @search="memberSearch"
            :clearSearchOnSelect="true"
            v-model="selectedRecord">

            <template slot="no-options">
                Type to find {{ type }}s that you are looking for
            </template>

            <template slot="option" slot-scope="option">
                <div class="d-center">
                    {{ option.fullname }}<br/>
                    <small>{{ option.email }}</small><br>
                    <small>{{ option.id }}</small>

                </div>
            </template>

            <template slot="selected-option" slot-scope="option">
                <div class="selected d-center">
                    {{ option.fullname }}
                    <small v-if="option.id">{{ option.id }}</small>
                </div>
            </template>
        </v-select>
    </div>
</template>

<script>
//Let's see if we can refactor this so that it is reusable for other Tables.

import vSelect from 'vue-select'

export default {
    name: "member-search",
    components: {vSelect},
    props: {
        value: {},
        type: {
            default: `member`,
            required: false,
            type: String,
        },
        clearOnHit: { //If we should clear the input box when a selection is made
            type: Boolean,
            required: false,
            default: true
        },
        placeholder: {
            type: String,
            default: "Type member name or ID",
            required: false
        }
    },
    data() {
        return {
            members: [],
            selectedRecord: {}, //The selected record
        }
    },
    created() {
        this.selectedRecord = this.value;
    },
    methods: {
        memberSearch(search, loading) {
            loading(true);
            this.search(this.type, search, loading, this);
        },
        search: _.debounce((type, search, loading, vm) => {
            var self = vm;

            if (type === `member`) {

                self.members = [];
                axios.get('/api/internal/members.json?name=' + search, {
                    headers: {
                        'Accept': 'application/json'
                    }
                }).then(function (response) {
                    response.data.data.forEach(function (item) {
                        var option = new Object();
                        option.id = item.id;
                        option.fullname = item.fullname;
                        option.first_name = item.first_name;
                        option.last_name = item.last_name;
                        option.email = item.email;
                        self.members.push(option);
                    });
                })

            } else if (type === `user`) {
                self.users = [];
                axios
                    .get(`/api/internal/users.json?search=${search}`, {
                        headers: {
                            Accept: `application/json`,
                        },
                    })
                    .then(response => {
                        let properties = ['first_name', 'fullname', 'id', 'last_name', 'email'];
                        Object.assign(self, {
                            members: response.data.data.map(user => Object.fromEntries(properties.map(property => [property, user[property]]))),
                        });
                    });
            }
            loading(false);
        }, 350),

    },
    watch: {
        selectedRecord(selectedRecord) {
            if (this.selectedRecord !== null && Object.keys(selectedRecord).length !== 0) {
                console.log(selectedRecord);
                this.$emit('input', selectedRecord)
            }
        },
        value(newVal) {
            if (this.clearOnHit && Object.keys(newVal).length === 0) {
                this.selectedRecord = {}; //Clear the search term
            }
        }
    }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/Assets/components/AAA_TO_REFACTOR/MemberSearch.vue